import { catchErrors } from './effectUtils'

type Handler = (payload?: unknown, action?: unknown) => unknown

interface Item {
  handler: Handler
  passAllOfAction: boolean
}

interface Subscriber {
  [type: string]: Item[]
}

export default class Subscription {
  subscribers: Subscriber = {}

  subscribersToAll: Handler[] = []

  subscribe(actionType: string, handler: Handler, passAllOfAction = false) {
    const itemToAdd = {
      handler: catchErrors(handler),
      passAllOfAction,
    }
    if (this.subscribers[actionType])
      this.subscribers[actionType].push(itemToAdd)
    else this.subscribers[actionType] = [itemToAdd]
  }

  subscribeToAll(handler: () => unknown) {
    this.subscribersToAll.push(catchErrors(handler))
  }

  publish(action: { type: string; payload: unknown }) {
    const { type, payload } = action
    if (this.subscribers[type])
      this.subscribers[type].forEach(({ handler, passAllOfAction }) =>
        passAllOfAction ? handler(action) : handler(payload, { action }),
      )
    this.subscribersToAll.forEach(handler => handler(action))
  }
}

export const serverSub = new Subscription()

export const wappSub = new Subscription()
